import React, { useState } from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  CircularProgress,
  Tooltip,
  Menu,
  MenuItem,
} from "@material-ui/core";



import { makeStyles } from "@material-ui/core/styles"; // Import makeStyles for custom styles
import EditDataForm from "../../../tables/EditDataForm.js"; // Import the Edit Form component
import axios from "axios";
import { BACKEND_BASE_URL } from "../../../../config.js";
import ShowMappingDialog from "./ShowMappingDialog.js";
import { toast } from "react-toastify";
import CorrectionDictionaryDialog from "./CorrectionDictionaryDialog.js";
// import { ro } from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#152F8F", // Set header background color
    color: "white", // Set header text color
    border: "1px solid #ddd", // Add border to header cells
     padding: "8px", 
  },
  header: {
    position: "sticky",
    top: 0,
    backgroundColor: "#152F8F",
    color: "white",
    zIndex: 1000, // Ensures header stays above body content
  },
  tableBodyWrapper: {
    maxHeight: "calc(100vh - 200px)", // Adjust based on header height
    overflowY: "auto", // Allows vertical scrolling of table body
    position: "relative",
    "&::-webkit-scrollbar": {
      width: "0px", // Hides scrollbar
      background: "transparent",
    },
  },
  table: {
    border: "1px solid #ddd", // Add border to the entire table
    minWidth: "800px", // Ensures the table is wider than the screen
  },
  tableContainer: {
    position: "relative", // Ensures relative positioning
    width: "100%",
    height: "calc(100vh - 150px)", // Adjust height to fit within the viewport
    display: "flex",
    flexDirection: "column",
  },

  tableWrapper: {
    marginBottom: theme.spacing(2),
    flexGrow: 1, // Makes it expand within the container
    overflowX: "auto", // Allows horizontal scrolling
    overflowY: "auto", // Allows vertical scrolling
    position: "relative", // Ensures proper positioning


  },
  responsiveTable: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem", // Adjust font size for smaller screens
    },
  },
  responsiveCell: {
    border: "1px solid #ddd",
    padding: "8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem", // Adjust cell font size for smaller screens
      padding: "4px", // Reduce padding for smaller screens
    },
  },
  responsiveButton: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.7rem", // Adjust button font size
      padding: "3px 3px", // Adjust button padding
    },
  },
  scrollbarContainer: {
    position: "fixed", // Fixes the scrollbar at the bottom
    bottom: 0, // Keeps it at the bottom of the screen
    left: 0,
    width: "100%",
    backgroundColor: "#fff", // Optional: background color for visibility
    borderTop: "1px solid #ddd",
    padding: "5px 0",
    zIndex: 1000, // Ensures it stays above other elements
  },
  scrollbar: {
    width: "100%",
    overflowX: "scroll",
  },
  narrowCell: {
    width: "70px", // adjust this as needed
    maxWidth: "70px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
   compactList: {
    margin: 0, // Remove default margin
    paddingLeft: "12px", // Reduce from default ~16px to 12px or 8px
    paddingTop: 0,
    paddingBottom: 0,
  },
  compactListItem: {
    margin: "2px 0", // Reduce vertical spacing between items
    padding: 0,
  },
}));

const TableComponent = ({
  data,
  handleDelete,
  handleDeleteAll,
  handleEdit,
  currentPage,
  itemsPerPage,
  api
}) => {

  const classes = useStyles();

  const [isEditDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isDeleteAllDialogOpen, setDeleteAllDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState({}); // { rowId: 'loading' | 'done' }
  const [correctionLoadingStatus, setCorrectionLoadingStatus] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRowData, setMenuRowData] = useState(null);
  const [mappingDialogOpen, setMappingDialogOpen] = useState(false);
  const [selectedMappingRow, setSelectedMappingRow] = useState(null);
  const [dictionaryDialogOpen, setDictionaryDialogOpen] = useState(false);
  const [selectedDictionaryRow, setSelectedDictionaryRow] = useState(null);

  const handleMenuOpen = (event, row) => {


    setAnchorEl(event.currentTarget);
    setMenuRowData(row); // Store the current row data
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowData(null);
  };

  // Open the Edit dialog with selected row data
  const handleEditClick = (rowData) => {

    setSelectedRowData(rowData); // Pass the selected row data to the form
    setEditDialogOpen(true); // Open the dialog
  };
  const getCSRFToken = () => {
    const csrfCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("csrftoken="));
    return csrfCookie ? csrfCookie.split("=")[1] : null;
  };

  // Handle close action of the Edit dialog
  const handleEditClose = () => {
    setEditDialogOpen(false);
    setSelectedRowData(null);
  };

  // Submit action for Edit form
  const handleEditSubmit = (updatedData) => {
    handleEdit(updatedData); // Pass updated data back to parent component
    handleEditClose(); // Close the dialog
  };

  // Open the Delete Confirmation Dialog
  const handleDeleteClick = (rowId) => {
    setRowToDelete(rowId);
    setDeleteDialogOpen(true);
  };

  // Close the Delete Confirmation Dialog
  const handleDeleteClose = () => {
    setDeleteDialogOpen(false);
    setRowToDelete(null);
  };

  // Confirm Delete Action
  const confirmDelete = () => {

    handleDelete(rowToDelete); // Trigger the delete function with selected row ID

    handleDeleteClose(); // Close the dialog
  };

  // Open the Delete all Confirmation Dialog
  const handleDeleteAllClick = (row) => {

    setRowToDelete(row);
    setDeleteAllDialogOpen(true);
  };

  // Close the Delete all Confirmation Dialog
  const handleDeleteAllClose = () => {
    setDeleteAllDialogOpen(false);
    setRowToDelete(null);
  };

  // Confirm Delete Action
  const confirmDeleteAll = () => {
    handleDeleteAll(rowToDelete); // Trigger the delete function with selected row ID
    handleDeleteAllClose(); // Close the dialog
  };

  const fetchKeywords = async () => {
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/keywords/`);
      const { keywords } = response.data;

      // Split keywords into different types based on 'type' field
      const townKeywords = keywords.filter((keyword) => keyword.type === "Town Government");
      const boardKeywords = keywords.filter((keyword) => keyword.type === "Board Of Education");

      return { townKeywords, boardKeywords }; // Return the keywords based on their type
    } catch (error) {
      console.error("Error fetching keywords:", error);
      return { townKeywords: [], boardKeywords: [] }; // Return empty arrays in case of error
    }
  };

  const handleShowMapping = (row) => {
    setSelectedMappingRow(row);
    setMappingDialogOpen(true);
  };

  const handleDictionary = (row) => {
    setSelectedDictionaryRow(row);
    setDictionaryDialogOpen(true);
  };

  const handleScrape = async (row, rowId) => {
    try {
      setLoadingStatus((prev) => ({ ...prev, [rowId]: "loading" })); // Set loading state
      const csrfToken = getCSRFToken();


      // Fetch keywords before making the API call
      const { townKeywords, boardKeywords } = await fetchKeywords();

      // Send the appropriate keywords to the API based on the channel type
      const channelKeywords = row.channel_type === "Town Government" ? townKeywords : boardKeywords;



      // Simulate an API call
      const response = await axios.post(
        `${BACKEND_BASE_URL}/api/scrape/`,
        { row, keywords: channelKeywords, api_key: api },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken, // Include the CSRF token
          },
          withCredentials: true, // Ensure cookies are sent with the request
        },
      );





      setLoadingStatus((prev) => ({ ...prev, [rowId]: "done" })); // Set done state
    } catch (error) {
      console.error("Error during scraping:", error);
      console.log("err:", error.response)

      let errorMessage =
        error.response?.message || "Error during scraping";

      // Handle network timeout errors FIRST
      if (error.code === "ERR_NETWORK") {
        console.log("err:", error.code)
        errorMessage = "Scraping started running in background...";
        toast.warning(errorMessage); // Show warning for timeout
        setLoadingStatus((prev) => ({ ...prev, [rowId]: "done" }));

      } else if (error.response?.status === 400) {
        errorMessage = error.response?.data?.error;
        toast.error(errorMessage);
        setLoadingStatus((prev) => ({ ...prev, [rowId]: null })); // Reset on error
      } else if (error.response?.status === 429) {
        errorMessage = error.response?.data?.message;
        toast.error(errorMessage);
        setLoadingStatus((prev) => ({ ...prev, [rowId]: null })); // Reset on error
      } else if (error.response?.status === 401) {
        errorMessage = error.response?.data?.message;
        toast.error(errorMessage);
        setLoadingStatus((prev) => ({ ...prev, [rowId]: null })); // Reset on error
      } else if (error.response?.status === 403) {
        errorMessage = error.response?.data?.message;
        toast.error(errorMessage);
        setLoadingStatus((prev) => ({ ...prev, [rowId]: null })); // Reset on error
      } else if (error.response?.status === 500) {
        errorMessage = error.response?.data?.message;
        toast.error(errorMessage);
        setLoadingStatus((prev) => ({ ...prev, [rowId]: null })); // Reset on error
      } else {
        toast.error(errorMessage);
        setLoadingStatus((prev) => ({ ...prev, [rowId]: null })); // Reset on error
      }
    }
  };

  const handleCorrection = async (rowId) => {
    setCorrectionLoadingStatus(prev => ({ ...prev, [rowId]: true }));

    try {
      const response = await axios.post(`${BACKEND_BASE_URL}/api/run-correction/`, {urltable_id: rowId });

      if (response.status === 201) {
        console.log("Correction Result:", response.data);

        toast.success("Task started in the background", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        throw new Error("Failed to run correction");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while starting the correction task", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setCorrectionLoadingStatus(prev => ({ ...prev, [rowId]: false }));
    }
  };


  return (
    <>
      <div className={classes.tableContainer} >
        <div className={classes.tableWrapper}>
          <Table className={`${classes.table} ${classes.responsiveTable}`}>
            <TableHead className={classes.header}>
              <TableRow>
                <TableCell className={classes.headerCell} style={{ width: '30px', minWidth: '30px' }}>S.No.</TableCell>
                <TableCell className={`${classes.headerCell} ${classes.narrowCell}`}>Country</TableCell>
                <TableCell className={`${classes.headerCell} ${classes.narrowCell}`}>State</TableCell>
                <TableCell className={`${classes.headerCell} ${classes.narrowCell}`}>County</TableCell>
                <TableCell className={classes.headerCell}>Town</TableCell>
                <TableCell className={classes.headerCell}>Channel Type</TableCell>
                <TableCell className={classes.headerCell}>Channel Name</TableCell>
                <TableCell className={classes.headerCell}>Playlists</TableCell>
                <TableCell className={classes.headerCell}>Notes</TableCell>
                {/* <TableCell className={classes.headerCell}>WEBSITE URL</TableCell> */}
                <TableCell className={classes.headerCell}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBodyWrapper}>

              {data.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{(currentPage - 1) * itemsPerPage + index + 1}.</TableCell>
                  <TableCell className={`${classes.responsiveCell} ${classes.narrowCell}`}>
                    {row.country}
                  </TableCell>
                  <TableCell className={`${classes.responsiveCell} ${classes.narrowCell}`}>
                    {row.state}
                  </TableCell>
                  <TableCell className={`${classes.responsiveCell} ${classes.narrowCell}`}>
                    {row.county}
                  </TableCell>
                  <TableCell className={classes.responsiveCell}>
                    {row.municipality_name}
                  </TableCell>
                  <TableCell className={classes.responsiveCell}>
                    {row.channel_type}
                  </TableCell>
                  <TableCell className={classes.responsiveCell}>
                    <Tooltip title={row.channel_url || "No URL available"} arrow>
                      <a
                        href={row.channel_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", cursor: "pointer" }}
                      >
                        {row.channel_name}
                      </a>
                    </Tooltip>
                  </TableCell>
                  <TableCell className={classes.responsiveCell}>
                    {row?.playlists?.length > 0 ? (
                      <ul className={classes.compactList}> 

                        {row.playlists.map((playlist) => (
                          <Tooltip
                            key={playlist.playlist_id}
                            title={playlist.playlist_id === "whole-channel" || playlist.playlist_id === "live-channel" ? row.channel_url : playlist.playlist_url || "No playlist available"}
                            arrow
                          >

                            <li className={classes.compactListItem}>
                              <a
                                href={playlist.playlist_id === "whole-channel" || playlist.playlist_id === "live-channel" ? row.channel_url : playlist.playlist_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                              >

                                {playlist.playlist_id === "whole-channel" ? "Main Channel" : playlist.playlist_name}
                              </a>
                            </li>
                          </Tooltip>
                        ))}
                      </ul>
                    ) : (
                      <span>No Playlists</span>
                    )}
                  </TableCell>

                  <TableCell className={classes.responsiveCell}>
                    {row.notes ? (

                      row.notes

                    ) : (
                      <>None</>
                    )}
                  </TableCell>

                  <TableCell className={classes.responsiveCell}>
                    <Box display={"flex"} flexDirection={"column"}>
                      <Box display="flex" flexDirection="row" width="100%">
                        <Button
                          variant="contained"
                          className={classes.responsiveButton}
                          style={{
                            marginRight: "10px",
                            backgroundColor: "#0B194A",
                            color: "white",
                          }}
                          onClick={() => handleEditClick(row)} // Open Edit dialog
                        >
                          <i
                            style={{ fontSize: "20px" }}
                            className="fa-solid fa-pen-to-square"
                          ></i>
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          className={classes.responsiveButton}
                          style={{ backgroundColor: "red" }}
                          onClick={(event) => handleMenuOpen(event, row)} // Pass the row data here
                        >
                          <span className="material-symbols-outlined">delete</span>
                        </Button>

                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          getContentAnchorEl={null}
                        >
                          <MenuItem
                            onClick={() => {
                              handleDeleteClick(menuRowData.id);
                              handleMenuClose();
                            }}
                          >
                            Delete URL
                          </MenuItem>
                          <MenuItem
                            onClick={() => {

                              handleDeleteAllClick(menuRowData);
                              handleMenuClose();
                            }}
                          >
                            Delete All Data
                          </MenuItem>
                        </Menu>
                      </Box>
                      <Button
                        variant="contained"
                        className={classes.responsiveButton}
                       
                        style={{
                          marginTop: "10px",
                          backgroundColor: `${loadingStatus[row.id] === "done"
                            ? "default"
                            : "#0B194A"
                            }`,
                          color: `${loadingStatus[row.id] === "done" ? "black" : "white"
                            }`,
                        }}
                        onClick={() => handleScrape(row, row.id)}
                        disabled={loadingStatus[row.id] === "loading"} // Disable during loading
                      >
                        {loadingStatus[row.id] === "loading" ? (
                          <>
                            <CircularProgress size={20} color="inherit" />
                            &nbsp;Scraping...
                          </>
                        ) : loadingStatus[row.id] === "done" ? (
                          <i
                            className="fa-solid fa-check"
                            style={{ color: "white" }}
                          ></i>
                        ) : (
                          "Scrape"
                        )}
                      </Button>
                      <Button
                        variant="contained"
                        style={{
                          marginTop: "10px",
                          backgroundColor: "#0B194A",
                          color: "white",
                        }}
                        onClick={() => handleCorrection(row.id)}
                        disabled={correctionLoadingStatus[row.id]}

                      >
                        {correctionLoadingStatus[row.id] ? (
                          <CircularProgress size={24} style={{ color: "white" }} />
                        ) : (
                          "Make Corrections"
                        )}

                      </Button>
                      {row.id && (
                        <p style={{ fontSize: "16px", marginBottom: "0px" }}>
                          <b>ID: {row.id}</b>
                        </p>
                      )}

                      {row.last_scraped && (
                        <p style={{ fontSize: "11px", marginBottom: "0px" }}>
                          <b>Last Updated:</b> {row.last_scraped}
                        </p>
                      )}

                      {row.associated_towns.length !== 0 && (
                        <p
                          style={{ fontSize: "11px", marginTop: "10px", cursor: "pointer", }}
                          onClick={() => handleShowMapping(row)}
                        >
                          <b>Show Mapping</b>
                        </p>
                      )}


                      <p
                        style={{ fontSize: "11px", marginTop: "10px", cursor: "pointer", }}
                        onClick={() => handleDictionary(row)}
                      >
                        <b>Correction Dictionary</b>
                      </p>


                    </Box>

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

        </div>
      </div>


      {/* Edit Dialog */}
      {selectedRowData && (
        <EditDataForm
          maxWidth="md"
          open={isEditDialogOpen}
          onClose={handleEditClose}
          onSubmit={handleEditSubmit}
          editData={selectedRowData} // Pass the selected row data to Edit form
          api={api}
        />
      )}

      <CorrectionDictionaryDialog
        open={dictionaryDialogOpen}
        onClose={() => setDictionaryDialogOpen(false)}
        row={selectedDictionaryRow}
      />

      {/* Delete Confirmation Dialog */}
      <Dialog
        maxWidth="sm"
        open={isDeleteDialogOpen}
        onClose={handleDeleteClose}
        aria-labelledby="delete-confirmation-dialog"
      >
        <DialogTitle id="delete-confirmation-dialog">
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            This will only delete the URL from this table. all the data will
            remain stored in the database.
          </DialogContentText>
          <DialogContentText sx={{ display: "block", marginTop: 1 }}>
            If you have deleted it once, you cannot add it again.
          </DialogContentText>
          <DialogContentText sx={{ marginTop: 1 }}>
            Are you sure you want to delete this entry? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose} color="primary" autoFocus>
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary">
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete ALL Confirmation Dialog */}
      <Dialog
        maxWidth="sm"
        open={isDeleteAllDialogOpen}
        onClose={handleDeleteAllClose}
        aria-labelledby="delete-confirmation-dialog"
      >
        <DialogTitle id="delete-confirmation-dialog">
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            This will only delete all the data that includes Transcript and
            Summaries related to this URL.
          </DialogContentText>

          <DialogContentText sx={{ marginTop: 1 }}>
            Are you sure you want to delete this data? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteAllClose} color="primary" autoFocus>
            Cancel
          </Button>
          <Button onClick={confirmDeleteAll} color="secondary">
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>

      <ShowMappingDialog
        open={mappingDialogOpen}
        onClose={() => setMappingDialogOpen(false)}
        rowData={selectedMappingRow}
      />

    </>
  );
};

export default TableComponent;
